import { addMinutes, format, isBefore, isSameDay, isSameHour, startOfDay, subDays } from 'date-fns';

export const clearTimezone = (date?: string): string => {
  if (date) {
    const d = new Date(date);

    // Added timezone offset to avoid show date shifts because we only care about date without time in this format
    return addMinutes(d, d.getTimezoneOffset()).toISOString();
  } else {
    return '-';
  }
};

export const formatExpiryDate = (date: string): string => {
  if (date.length !== 4) return date;
  return `${date.slice(0, 2)}/${date.slice(2)}`;
};

export const formatDateYear = (date?: string, dateFormat?: string): string => {
  if (date) {
    const formatToUse = dateFormat ?? 'EEE d MMM yyyy';
    return format(date, formatToUse);
  } else {
    return '-';
  }
};

export const formatDayTime = (dayTime?: string): string => {
  if (dayTime) {
    return format(new Date(dayTime), 'EEE d MMM h:mma');
  } else {
    return '-';
  }
};

export const smartFormatDate = (dayTime: string): string => {
  if (dayTime.length > 0) {
    const date = new Date(dayTime);
    if (isBefore(date, startOfDay(subDays(new Date(), 7)))) {
      return format(date, 'M/d/yy');
    } else if (isBefore(date, startOfDay(subDays(new Date(), 1)))) {
      return format(date, 'EEEE');
    } else if (isBefore(date, startOfDay(new Date()))) {
      return 'Yesterday';
    } else {
      return format(date, 'h:mma');
    }
  } else {
    return '-';
  }
};

export const formatDateTimeRange = (
  startDateStr?: string,
  endDateStr?: string
): { date: string; time: string } | undefined => {
  if (startDateStr && endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    // Format the day parts
    const startDay = format(startDate, 'MMMM do');
    const endDay = format(endDate, 'do');
    const datePart = isSameDay(startDate, endDate) ? startDay : `${startDay} - ${endDay}`;

    // Format the time parts
    const startTime = format(startDate, 'h:mmaaa').toLowerCase();
    const endTime = format(endDate, 'h:mmaaa').toLowerCase();
    const timePart = isSameHour(startDate, endDate) ? startTime : `${startTime} - ${endTime}`;

    return { date: datePart, time: timePart };
  }
};
